import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      width: "100%",
      height: "fit-content",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    mainPanel: {
      width: 350,
      background: "transparent"
    },
    description: {
      color: theme.palette.grey[700]
    },
    headTextLogo: {
      margin: "5px 0 40px 0",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      transition: "all 0.5s ease"
    },
    text: {
      color: "#E41B17",
      fontWeight: "bold",
      fontSize: 30,
      padding: "5px 35px",
      paddingLeft: 0,
      borderRight: "solid 1px #E41B17"
    },
    logo: {
      marginLeft: 20
    },
    typeButton: {
      width: "100%",
      height: 48,
      marginBottom: 20
    },
    typeButtonSCG: {
      marginBottom: 30
    },
    arrow: {
      transform: "rotate(180deg)"
    },
    backBtn: {
      marginBottom: theme.spacing(3)
    },
    buttonContainer: {
      display: "flex",
      marginTop: theme.spacing(2)
    },
    header: {
      color: theme.palette.grey[800],
      fontWeight: 700,
      marginBottom: theme.spacing(2)
    },
    overideLablel: {
      "& .MuiInputLabel-root.MuiFormLabel-filled.Mui-error": {
        color: theme.palette.scgPrimary.main
      }
    },
    link: {
      color: theme.palette.grey[900],
      cursor: "pointer",
      display: "block",
      margin: theme.spacing(2, 0),
      textAlign: "right",
      "&:hover": {
        color: theme.palette.info.main
      }
    },
    linkBack: {
      color: theme.palette.grey[900],
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      marginRight: theme.spacing(2),
      textAlign: "right",
      "& img": {
        marginRight: "1rem"
      }
    },
    loading: {
      alignItems: "center",
      display: "flex",
      minHeight: "80vh",
      justifyContent: "center"
    },
    loginButton: {
      width: "50%",
      marginLeft: "auto"
    },
    resetPasswordSendButton: {
      "& .MuiButton-label": {
        fontWeight: 700
      }
    },
    panel: {
      "& span": {
        color: theme.palette.error.contrastText
      },
      ...theme.typography.body1,
      background: theme.palette.alert.paper.error,
      borderRadius: 8,
      marginBottom: theme.spacing(2),
      padding: theme.spacing(2.5)
    },
    passwordWrapper: {
      position: "relative"
    },
    showPasswordBtn: {
      position: "absolute",
      top: 18,
      right: 8
    },
    submit: {
      width: "100%"
    },
    textError: {
      fontSize: "12px",
      marginTop: "4px",
      color: theme.palette.error.light
    },
    footerForgotPassword: {
      marginTop: "6rem"
    },
    bold: {
      fontWeight: 700
    },
    infoResetPassWord: {
      marginTop: "10px",
      display: "flex",
      alignItems: "center",
      "& .MuiTypography-root": {
        marginLeft: "10px"
      }
    },
    snackHeadTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      columnGap: "1.2rem"
    },
    backDrop: {
      zIndex: 99
    },
    mailTitle: {
      display: "flex",
      alignItems: "center",
      marginBottom: "16px",
      "& img": {
        marginRight: "10px"
      },
      "& .MuiTypography-root": {
        marginBottom: 0
      }
    },
    textLink: {
      cursor: "pointer",
      color: theme.palette.indigo.main,
      lineHeight: "22px"
    },
    dividerLink: {
      width: "1px",
      height: "14px",
      backgroundColor: theme.palette.indigo.main,
      marginLeft: "16px",
      marginRight: "16px"
    },
    turnstile: {
      marginTop: "1rem",
      textAlign: "center"
    }
  }),
  { name: "Login" }
);

export default useStyles;
